import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { LogoMark, LogoWord } from "../components/Logo";
import Seo from "../components/Seo";
import { api, formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/api/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-lg border border-[#2E333D] bg-[#141619] px-4 py-3.5 text-base text-[#F9FAFB] placeholder:text-gray-600 focus:border-[#FFC700] focus:outline-none transition-colors";

  return (
    <div className="bg-[#0C0D0E] min-h-screen flex items-center justify-center px-4" data-testid="admin-login-page">
      <Seo title="Administration — STOCKBOX 8" noindex />
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <LogoMark size={30} />
          <LogoWord />
        </div>
        <form onSubmit={submit} className="border border-[#2E333D] bg-[#141619] rounded-2xl p-8 space-y-5" data-testid="admin-login-form">
          <div className="flex items-center gap-2 text-gray-400">
            <Lock size={15} className="text-[#FFC700]" />
            <h1 className="font-mono text-xs uppercase tracking-[0.25em]">Espace administrateur</h1>
          </div>
          <div>
            <label className="block font-mono text-[11px] uppercase tracking-[0.2em] text-gray-400 mb-2" htmlFor="admin-email">Email</label>
            <input id="admin-email" data-testid="admin-email-input" type="email" required className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@stockbox8.fr" />
          </div>
          <div>
            <label className="block font-mono text-[11px] uppercase tracking-[0.2em] text-gray-400 mb-2" htmlFor="admin-password">Mot de passe</label>
            <input id="admin-password" data-testid="admin-password-input" type="password" required className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••••" />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 bg-[#FFC700] text-[#0C0D0E] font-bold text-sm px-6 py-3.5 rounded-full uppercase tracking-wide hover:bg-[#FFD83D] disabled:opacity-60 transition-colors">
            {loading ? <Loader2 size={17} className="animate-spin" /> : null}
            Se connecter
          </button>
        </form>
        <a href="/" className="mt-6 block text-center text-sm text-gray-600 hover:text-[#FFC700] transition-colors" data-testid="admin-back-link">
          ← Retour au site
        </a>
      </div>
    </div>
  );
}
